"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let path = /*#__PURE__*/_react.default.createElement("g", {
  id: "project_1_",
  "data-name": "project (1)",
  transform: "translate(0 -0.007)"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2173",
  "data-name": "Trac\xE9 2173",
  d: "M22.347,24.374a1.66,1.66,0,0,1-1.234-.543,1.68,1.68,0,0,1,.1-2.372A13.187,13.187,0,0,1,30.163,18a1.677,1.677,0,0,1,0,3.355,9.846,9.846,0,0,0-6.682,2.576,1.674,1.674,0,0,1-1.134.443Z",
  transform: "translate(48.669 42.364)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2174",
  "data-name": "Trac\xE9 2174",
  d: "M9.493,24.374a1.658,1.658,0,0,1-1.134-.443,9.846,9.846,0,0,0-6.682-2.576,1.677,1.677,0,0,1,0-3.355,13.174,13.174,0,0,1,8.95,3.462,1.676,1.676,0,0,1-1.134,2.912Z",
  transform: "translate(0 42.364)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2175",
  "data-name": "Trac\xE9 2175",
  d: "M3.684,30.064a1.677,1.677,0,0,1-1.4-2.6A16.742,16.742,0,0,1,29.1,26.042a1.677,1.677,0,1,1-2.583,2.14,13.387,13.387,0,0,0-21.429,1.13,1.681,1.681,0,0,1-1.4.751Z",
  transform: "translate(4.733 47.073)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2176",
  "data-name": "Trac\xE9 2176",
  d: "M39.6,30.064a1.676,1.676,0,0,1-1.4-.751,13.39,13.39,0,0,0-21.432-1.13,1.677,1.677,0,1,1-2.583-2.14A16.742,16.742,0,0,1,41,27.46a1.677,1.677,0,0,1-1.4,2.6Z",
  transform: "translate(32.492 47.073)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2177",
  "data-name": "Trac\xE9 2177",
  d: "M29.506,29.886a1.681,1.681,0,0,1-1.382-.721,9.981,9.981,0,0,0-16.427,0A1.678,1.678,0,0,1,8.94,27.253a13.341,13.341,0,0,1,21.945,0,1.677,1.677,0,0,1-1.379,2.633Z",
  transform: "translate(20.342 50.605)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2178",
  "data-name": "Trac\xE9 2178",
  d: "M50.286,60.364H6.677A1.678,1.678,0,0,1,5,58.687V54.758a8.333,8.333,0,0,1,2.456-5.931l7.608-7.608V20.12A15.1,15.1,0,0,1,18.8,10.18L27.217.556a1.728,1.728,0,0,1,2.526,0l8.42,9.624A15.089,15.089,0,0,1,41.9,20.12v21.1l7.608,7.608a8.333,8.333,0,0,1,2.456,5.931v3.928A1.678,1.678,0,0,1,50.286,60.364ZM8.355,57.009H48.609V54.758A5.007,5.007,0,0,0,47.136,51.2l-8.1-8.1a1.678,1.678,0,0,1-.493-1.187V20.12a11.746,11.746,0,0,0-2.905-7.732L28.482,4.206l-7.159,8.182a11.746,11.746,0,0,0-2.905,7.732V41.914a1.689,1.689,0,0,1-.49,1.188l-8.1,8.1a4.99,4.99,0,0,0-1.476,3.559Z",
  transform: "translate(11.773 0)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2179",
  "data-name": "Trac\xE9 2179",
  d: "M17.677,25.386A1.678,1.678,0,0,1,16,23.709V18.677a1.677,1.677,0,0,1,3.355,0v5.032A1.678,1.678,0,0,1,17.677,25.386Z",
  transform: "translate(37.672 40.009)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2180",
  "data-name": "Trac\xE9 2180",
  d: "M8.677,25.386A1.678,1.678,0,0,1,7,23.709V18.677a1.677,1.677,0,0,1,3.355,0v5.032A1.678,1.678,0,0,1,8.677,25.386Z",
  transform: "translate(16.482 40.009)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2181",
  "data-name": "Trac\xE9 2181",
  d: "M21.741,10.432a1.685,1.685,0,0,1-1.187-.49,5.446,5.446,0,0,0-7.692,0A1.677,1.677,0,1,1,10.49,7.571a8.809,8.809,0,0,1,12.435,0,1.676,1.676,0,0,1-1.184,2.861Z",
  transform: "translate(23.545 11.76)",
  fill: "#fff"
}));
let viewBox = '0 0 80.509 80.485';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'ConstructionIcon', viewBox);
